import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

interface OvertimeComponentProps {
    text: string
}

export default function OvertimeComponent(props: OvertimeComponentProps) {
    return (
        <React.Fragment>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
                width="100%"
            >
                <Box display="flex">
                    <Typography
                        variant="h3"
                        color="green"
                        noWrap
                    >
                        +{props.text}
                    </Typography>
                </Box>
            </Box>
        </React.Fragment>
    );
}